module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-warn-04c0f83ea9c9dc4fdfecfd319df44dc8.svg";